module.exports = __webpack_public_path__ + "img/perspective-02.a60262d3.svg";